import { DOCUMENT } from '@angular/common';
import { InjectionToken, inject } from '@angular/core';

export const RECARGAR_DOCUMENTO = new InjectionToken<(url?: string) => void>('RECARGAR_DOCUMENTO', {
  providedIn: 'root',
  factory: () => {
    const ventana = inject(DOCUMENT).defaultView;
    return (url?: string) => (url ? ventana?.location.assign(url) : ventana?.location.reload());
  },
});
